import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-chat" }, null, -1)
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getters.channels, (entry) => {
    return (_openBlock(), _createElementBlock("span", {
      class: "nav-wrapper",
      key: entry.id
    }, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "menuItem",
          to: { name: 'channel', params: { id: entry.id, title: entry.title }}
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("span", {
              class: _normalizeClass(["entry", {'unread': (entry.unread > 0)}])
            }, _toDisplayString(entry.title), 3),
            (entry.unread > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "badge bg-secondary me-3",
                  textContent: _toDisplayString(entry.unread)
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["to"])
      ])
    ]))
  }), 128))
}